module.exports = __webpack_public_path__ + "static/media/overview.4db434e9.jpg";